import { isChineseDomain } from './is-chinese-domain';
import { isAbsoluteHttpsUrl } from '../utils/helper-functions/read-embedded-cashier-css.ts';

const loaderLink = `${
  isChineseDomain
    ? 'https://alt-cdn.prx-pay.com/images/Cashier_cubes_preloader.gif'
    : 'https://assets.praxispay.com/images/Cashier_cubes_preloader.gif'
}`;

const styles = `
.loader-container {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 15px;
}
.loader{
   width: 50px;
   height: 50px;
   background-image: url(${loaderLink});
   background-size: contain;
   z-index: 1;
}
.timer-text {
   font-size: 16px;
   color: #333333;
   padding-top: 10px;
   font-family: 'Open Sans', sans-serif;
   display: none;
}
.loader-text-wrapper {
    position: absolute;
    top: calc(50% + 43px);
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}
.loader-container:has(.loader-pano) .loader-text-wrapper {
    top: calc(50% + 48px);
}
.pano-timer-text {
   font-size: 14px;
   color: #16181D;
   font-family: Inter, sans-serif;
   display: none;
}
.loader-text{
    padding: 10px;
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    text-align: center;
    color: #4980aa;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 50px;
}
.loader-delay-text {
   display: none;
   font-size: 16px;
   color: #333333;
   padding-top: 10px;
   font-family: 'Open Sans', sans-serif;
   text-align: center;
}
.pano-loader-delay-text {
   display: none;
   font-size: 14px;
   color: #16181D;
   padding-top: 12px;
   font-family: Inter, sans-serif;
   text-align: center;
}
.pano-loader-text {
    font-size: 14px;
    font-weight: 400;
    color: #16181D;
    font-family: Inter, sans-serif;
}
.loader-pano {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #16181D;
}
.loader-pano svg {
    display: block;
    margin: 0 auto;
}
.loader-pano path {
    animation: spinnerFade 1s linear infinite;
}
.loader-pano path:nth-child(1) { animation-delay: 0s; }
.loader-pano path:nth-child(2) { animation-delay: 0.125s; }
.loader-pano path:nth-child(3) { animation-delay: 0.25s; }
.loader-pano path:nth-child(4) { animation-delay: 0.375s; }
.loader-pano path:nth-child(5) { animation-delay: 0.5s; }
.loader-pano path:nth-child(6) { animation-delay: 0.625s; }
.loader-pano path:nth-child(7) { animation-delay: 0.75s; }
.loader-pano path:nth-child(8) { animation-delay: 0.875s; }

@keyframes spinnerFade {
    0% { opacity: 1; }
    100% { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
    .loader-pano path { animation-duration: 2s; }
}
`;

export const escapeStyleText = (text) => text.replace(/<\/style/gi, '<\\/style');

export const encodeAttribute = (text) =>
  text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const getMerchantCssBlock = (cashier_css, embedded_cashier_css, embedded_cashier_css_url) => {
  const oldBlock = `<style>
            ${cashier_css}
        </style>`;

  if (typeof cashier_css === 'string' && cashier_css !== '') return oldBlock;
  if (typeof embedded_cashier_css === 'string' && embedded_cashier_css !== '') {
    return `<style>${escapeStyleText(embedded_cashier_css)}</style>`;
  }
  if (
    typeof embedded_cashier_css_url === 'string' &&
    isAbsoluteHttpsUrl(embedded_cashier_css_url)
  ) {
    return `<link rel="stylesheet" href="${encodeAttribute(embedded_cashier_css_url)}" blocking="render">`;
  }
  return oldBlock;
};

export const redirectWindowDom = (
  langBack,
  cashier_theme,
  cashier_css,
  embedded_cashier_css = '',
  embedded_cashier_css_url = '',
) =>
  `<html>
    <head>
        <title>Redirect url...</title>
        <style>
            ${styles}
        </style>
        ${getMerchantCssBlock(cashier_css, embedded_cashier_css, embedded_cashier_css_url)}
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
    </head>
    <body>
    <div class="popupWrapper">
        <div class="loader-container">
            ${
              cashier_theme === 'panoramic-2-0-theme'
                ? `
                <div class="loader-pano">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g transform="translate(4.5 4.5)">
                                <path d="M21 1.5V7.5C21 7.89782 20.842 8.27936 20.5607 8.56066C20.2794 8.84196 19.8978 9 19.5 9C19.1022 9 18.7206 8.84196 18.4393 8.56066C18.158 8.27936 18 7.89782 18 7.5V1.5C18 1.10218 18.158 0.720644 18.4393 0.43934C18.7206 0.158035 19.1022 0 19.5 0C19.8978 0 20.2794 0.158035 20.5607 0.43934C20.842 0.720644 21 1.10218 21 1.5Z" fill="currentColor"/>
                                <path d="M27.9844 12.5156C28.1815 12.5155 28.3768 12.4766 28.5589 12.401C28.741 12.3254 28.9064 12.2146 29.0456 12.075L33.2887 7.83375C33.5702 7.55229 33.7283 7.17055 33.7283 6.7725C33.7283 6.37445 33.5702 5.99271 33.2887 5.71125C33.0073 5.42979 32.6255 5.27167 32.2275 5.27167C31.8295 5.27167 31.4477 5.42979 31.1663 5.71125L26.925 9.95437C26.7151 10.164 26.5721 10.4313 26.514 10.7222C26.456 11.0132 26.4856 11.3148 26.599 11.5889C26.7124 11.8631 26.9045 12.0975 27.1511 12.2624C27.3977 12.4274 27.6877 12.5155 27.9844 12.5156Z" fill="currentColor"/>
                                <path d="M37.5 18H31.5C31.1022 18 30.7206 18.158 30.4393 18.4393C30.158 18.7206 30 19.1022 30 19.5C30 19.8978 30.158 20.2794 30.4393 20.5607C30.7206 20.842 31.1022 21 31.5 21H37.5C37.8978 21 38.2794 20.842 38.5607 20.5607C38.842 20.2794 39 19.8978 39 19.5C39 19.1022 38.842 18.7206 38.5607 18.4393C38.2794 18.158 37.8978 18 37.5 18Z" fill="currentColor"/>
                                <path d="M29.0456 26.925C28.762 26.6556 28.3844 26.5076 27.9933 26.5126C27.6021 26.5176 27.2284 26.6752 26.9518 26.9518C26.6752 27.2284 26.5176 27.6021 26.5126 27.9933C26.5076 28.3844 26.6556 28.762 26.925 29.0456L31.1663 33.2887C31.4477 33.5702 31.8295 33.7283 32.2275 33.7283C32.6255 33.7283 33.0073 33.5702 33.2887 33.2887C33.5702 33.0073 33.7283 32.6255 33.7283 32.2275C33.7283 31.8295 33.5702 31.4477 33.2887 31.1663L29.0456 26.925Z" fill="currentColor"/>
                                <path d="M19.5 30C19.1022 30 18.7206 30.158 18.4393 30.4393C18.158 30.7206 18 31.1022 18 31.5V37.5C18 37.8978 18.158 38.2794 18.4393 38.5607C18.7206 38.842 19.1022 39 19.5 39C19.8978 39 20.2794 38.842 20.5607 38.5607C20.842 38.2794 21 37.8978 21 37.5V31.5C21 31.1022 20.842 30.7206 20.5607 30.4393C20.2794 30.158 19.8978 30 19.5 30Z" fill="currentColor"/>
                                <path d="M9.95437 26.925L5.71125 31.1663C5.42979 31.4477 5.27167 31.8295 5.27167 32.2275C5.27167 32.6255 5.42979 33.0073 5.71125 33.2887C5.99271 33.5702 6.37445 33.7283 6.7725 33.7283C7.17055 33.7283 7.55229 33.5702 7.83375 33.2887L12.075 29.0456C12.3444 28.762 12.4924 28.3844 12.4874 27.9933C12.4824 27.6021 12.3248 27.2284 12.0482 26.9518C11.7716 26.6752 11.3979 26.5176 11.0067 26.5126C10.6156 26.5076 10.238 26.6556 9.95437 26.925Z" fill="currentColor"/>
                                <path d="M9 19.5C9 19.1022 8.84196 18.7206 8.56066 18.4393C8.27936 18.158 7.89782 18 7.5 18H1.5C1.10218 18 0.720644 18.158 0.43934 18.4393C0.158035 18.7206 0 19.1022 0 19.5C0 19.8978 0.158035 20.2794 0.43934 20.5607C0.720644 20.842 1.10218 21 1.5 21H7.5C7.89782 21 8.27936 20.842 8.56066 20.5607C8.84196 20.2794 9 19.8978 9 19.5Z" fill="currentColor"/>
                                <path d="M7.83375 5.71125C7.55229 5.42979 7.17055 5.27167 6.7725 5.27167C6.37445 5.27167 5.99271 5.42979 5.71125 5.71125C5.42979 5.99271 5.27167 6.37445 5.27167 6.7725C5.27167 7.17055 5.42979 7.55229 5.71125 7.83375L9.95437 12.075C10.238 12.3444 10.6156 12.4924 11.0067 12.4874C11.3979 12.4824 11.7716 12.3248 12.0482 12.0482C12.3248 11.7716 12.4824 11.3979 12.4874 11.0067C12.4924 10.6156 12.3444 10.238 12.075 9.95437L7.83375 5.71125Z" fill="currentColor"/>
                        </g>
                    </svg>
                </div>
            `
                : `
                <div class="loader"></div>
            `
            }

            <div class="loader-text-wrapper">
                <div class="${cashier_theme === 'panoramic-2-0-theme' ? 'pano-loader-delay-text' : 'loader-delay-text'}">
                    ${langBack('delayLoaderText')}
                </div>
                <div class="${cashier_theme === 'panoramic-2-0-theme' ? 'pano-timer-text' : 'timer-text'}"></div>

                ${
                  cashier_theme === 'panoramic-2-0-theme'
                    ? `
                    <div class="pano-loader-text">
                        ${langBack('Please do not close this window.')}
                    </div>
                `
                    : `
                    <div class="loader-text">
                        ${langBack('Loading... Please Wait')}
                    </div>
                `
                }
            </div>
        </div>
    </div>
    <script>
        const newDate = new Date(0, 0, 0, 0, 5, 0)
        const timerFormat = new Intl.DateTimeFormat('gb', {minute: "numeric", second: "numeric"})
        const timer = document.querySelector('.timer-text')
        const delayLoaderText = document.querySelector('.loader-delay-text');
    
        if(delayLoaderText) {
            setTimeout(() => {
                delayLoaderText.style.display = 'block';
            }, 15000)
        }
        
        setTimeout(() => {
            timer.style.display = 'block'
        }, 60000)

        const interval = setInterval(() => {
            newDate.setSeconds(newDate.getSeconds() - 1)
            timer.innerText = timerFormat.format(newDate)
            if (newDate.getMinutes() === 0 && newDate.getSeconds() === 0) {
                clearInterval(interval)
            }
        }, 1000)
        window.onclose = () => {
            clearInterval(interval)
        }
    </script>
    </body>
    </html>`;
